import React, { useMemo, useState } from "react";
import Input from "components/Input";
import Text from "components/Text";
import { Modal, ModalBody } from "reactstrap";
import styles from "../../Appointments/Appointments.module.scss";
import {
  blockRepeatDateSlot,
  blockSelectedDateSlot,
} from "repositories/patient-appointment-repository";
import { useMutation } from "react-query";
import Loader from "components/Loader";
import moment from "moment";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import RepeatEventDropDowns from "accountOwner/pages/AddEvent/RepeatEventDropDowns";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import CustomDropdown from "components/Dropdown";
import toast from "react-hot-toast";
import { setterCustomSchduler } from "accountOwner/pages/AddEvent/addEvents.functions";
import crossIcon from "assets/images/cross.svg"
const BlockTimeSlot = ({
  t,
  blockReason,
  setBlockReason,
  setModalOpen,
  modalOpen,
  officeId,
  selectedSlotDate,
  doctorId,
  selectedSlots,
  setSelectedSlots,
}) => {
  // const [radioState, setRadioState] = useState({
  //   blockOnly: true,
  //   repeatday: false,
  //   repeatEveryday: false,
  // });
  const selectedDate = useMemo(
    () => new Date(selectedSlotDate),
    [selectedSlotDate]
  );
  const [error, setError] = useState({});
  const [repeatedType, setRepeatedType] = useState(1);
  const [startDate, setStartDate] = useState(new Date(selectedDate));
  const [repeatedEndDate, setRepeatedEndDate] = useState(
    moment(selectedDate).add(3, "month").toDate()
  );
  const [repeatedTypeFrequency, setRepeatedTypeFrequency] = useState(1);
  const [repeatedTypeEvery, setRepeatedTypeEvery] = useState(1);
  const [schedule, setSchedule] = useState([
    selectedDate.getDay() === 0 ? 7 : selectedDate.getDay(),
  ]);
  const [selectionType, setSelectionType] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(() => {
    const startOfMonth = moment(selectedDate).clone().startOf("month");
    return moment(selectedDate).diff(startOfMonth, "weeks") + 1;
  });
  const [selectedDay, setSelectedDay] = useState(
    selectedDate.getDay() === 0 ? 7 : selectedDate.getDay()
  );
  const [isDaySwitchOn, setIsDaySwitchOn] = useState(false);
  const [customSelectedSlotDate, setCustomSelectedSlotDate] = useState([
    selectedDate.getDate(),
  ]);
  const [selectedMonths, setSelectedMonths] = useState([
    selectedDate.getMonth() + 1,
  ]);

  const repeatOptions = useMemo(
    () => addEditEventsConst.repeatedOptions(t),
    []
  );
  const { mutate: blockSelectedDate, isLoading: blockSelectedDateLoading } =
    useMutation((data) => blockSelectedDateSlot(data));
  const { mutate: blockRepeatDate, isLoading: blockRepeatDateSlotLoading } =
    useMutation((data) => blockRepeatDateSlot(data));

  const handleChange = (e) => {
    setBlockReason(e.target.value);
    if (error?.blockReason && e.target.value.trim()) {
      setError((prev) => {
        delete prev["blockReason"];
        return {
          ...prev,
        };
      });
    }
  };

  const handleClick = () => {
    if (!blockReason?.length) {
      setError((prev) => ({
        ...prev,
        blockReason: t("patientAppointmentMembers.addYourComment"),
      }));
    } else if (blockReason?.length > 500) {
      setError((prev) => ({
        ...prev,
        blockReason: t("patientAppointmentMembers.reasonBlock"),
      }));
    } else {
      if (Object.keys(error).length) setError({});
      const startTimes = selectedSlots
        ?.filter((app) => app.startTime)
        ?.map((app) => app.startTime);
      const params = {
        officeId: officeId,
        date: moment(startDate).format("YYYY-MM-DD"),
        doctorId: doctorId,
        slots: startTimes,
        reason: blockReason,
        RepeatedType: +repeatedType,
      };
      if (repeatedType === addEditEventsConst.repeatedOptionsValues.never) {
        blockSelectedDate(params, {
          onSuccess: (res) => {
            setSelectedSlots([]);
            setBlockReason("");
            toast.success(res.message);
            setModalOpen(false);
          },
          onError: (res) => {
            toast.error(res.message);
          },
        });
      } else {
        setterCustomSchduler({
          params,
          repeatedType,
          repeatedTypeFrequency,
          repeatedTypeEvery,
          selectionType,
          schedule,
          selectedSlotDate: customSelectedSlotDate,
          selectedWeek,
          selectedDay,
          selectedMonths,
          isDaySwitchOn,
        });
        params.TimeSlotEndDate = moment(repeatedEndDate).format("YYYY-MM-DD");
        blockRepeatDate(params, {
          onSuccess: (res) => {
            setSelectedSlots([]);
            setBlockReason("");
            toast.success(res.message);
            setModalOpen(false);
          },
          onError: (res) => {
            toast.error(res.message);
          },
        });
      }
    }
  };
  const loader = blockSelectedDateLoading || blockRepeatDateSlotLoading;
  return (
    <Modal
      toggle={() => setModalOpen(!modalOpen)}
      isOpen={modalOpen}
      className="modal-dialog-centered deactivate-modal modal-width-660"
    >
      {loader && <Loader />}
      <div className={styles["timeslot-modal"]}>
        <ModalBody
          className={
            styles[" modal-content-part"] + " " + "d-flex flex-column p-0"
          }
        >
          <div>
            <span
              className={
                styles["close-btn"] + " " + "d-flex justify-content-end"
              }
              onClick={() => setModalOpen(!modalOpen)}
            >
              <img
                src={crossIcon}
                alt="close"
              />
            </span>
            <div>
              <Text
                size="25px"
                weight="500"
                color="#111B45"
                marginBottom="30px"
              >
                {t("patientAppointmentMembers.blockTimeSlot")}
              </Text>
            </div>
          </div>
          <div className="c-field">
            <label>{t("accountOwner.date")}</label>
            <div className="d-flex inputdate">
              <ReactDatePickerCommon
                dateFormat="dd-MM-yyyy"
                className="c-form-control"
                onChange={(e) => {
                  setStartDate(e);
                  setRepeatedEndDate(moment(e).add(3, "month").toDate());
                }}
                minDate={new Date()}
                selected={startDate}
              />
            </div>
          </div>
          <div className="c-field">
            <label>{t("repeat")}</label>
            <div className="custom-dropdown-only">
              <CustomDropdown
                options={repeatOptions}
                selectedOption={repeatedType}
                selectOption={(id) => {
                  setRepeatedType(id);
                }}
              />
            </div>
          </div>
          {repeatedType === addEditEventsConst.repeatedOptionsValues.custom && (
            <RepeatEventDropDowns
              selectionType={selectionType}
              selectedSlotDate={customSelectedSlotDate}
              selectedWeek={selectedWeek}
              selectedDay={selectedDay}
              selectedMonths={selectedMonths}
              isDaySwitchOn={isDaySwitchOn}
              repeatedTypeEvery={repeatedTypeEvery}
              repeatedTypeFrequency={repeatedTypeFrequency}
              setSchedule={setSchedule}
              setSelectedMonths={setSelectedMonths}
              setSelectedSlotDate={setCustomSelectedSlotDate}
              schedule={schedule}
              setRepeatedTypeEvery={setRepeatedTypeEvery}
              setRepeatedTypeFrequency={setRepeatedTypeFrequency}
              setSelectionType={setSelectionType}
              setSelectedWeek={setSelectedWeek}
              setSelectedDay={setSelectedDay}
              setIsDaySwitchOn={setIsDaySwitchOn}
            />
          )}
          {repeatedType !== 1 && (
            <div className="c-field mt-4">
              <label>End Date</label>
              <div className="d-flex inputdate">
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className="c-form-control"
                  onChange={(e) => {
                    setRepeatedEndDate(e);
                  }}
                  minDate={startDate}
                  selected={repeatedEndDate}
                />
              </div>
            </div>
          )}
          <div className="mt-4">
            <Input
              Title="Reason of Blocking Timeslot"
              Type="text"
              Placeholder="Reason"
              Name={"BlockReason"}
              Value={blockReason}
              HandleChange={handleChange}
              Error={error.blockReason}
            />
          </div>
          <div className={styles["common-appointment-btn-container"]}>
            <button
              className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
              onClick={handleClick}
            >
              {" "}
              {t("patientAppointmentMembers.submit")}{" "}
            </button>
            <button
              className="button button-round button-border button-dark btn-mobile-link"
              onClick={() => setModalOpen(!modalOpen)}
            >
              {" "}
              {t("patientAppointmentMembers.cancel")}{" "}
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default BlockTimeSlot;
